import AssignedTechnician from "./AssignedTechnician";

export default AssignedTechnician